<template>
	<sf-modal-layout class="qms-xxl" :title="mkObjPopUpInfo.title" :show="display" :closeModal="close">
		<div class="sf-actions">
			<div className="sf-actions__left">
				<template v-if="mkObjPopUp.btnApprAuth">
					<!--승인-->
					<sf-button size="sm" v-if="isButton_(scrId, 'CS')" line icon="round-check-on" :onClick="apprSaveAction">
						{{ getMessage_('QWCC001001') }}
					</sf-button>

					<!--반려-->
					<sf-button size="sm" v-if="isButton_(scrId, 'GV')" line icon="circle-close" :onClick="OpenApprPopup1">
						{{ getMessage_('QWCC001003') }}
					</sf-button>
				</template>

				<!--초기화
				<sf-button size="sm" v-if="mkObjPopUp.btnTsAuth" line icon="file" :onClick="tmpClearAction">
					{{ getMessage_('QWCC001109') }}
				</sf-button>
				-->

				<!--삭제-->
				<sf-button size="sm" v-if="mkObjPopUp.btnDelAuth" line icon="trash" color="error" :onClick="delAction">
					{{ getMessage_('MWCC000328') }}
				</sf-button>

				<!--신청-->
				<sf-button size="sm" v-if="mkObjPopUp.btnApAuth" line icon="round-check-on" :onClick="appSaveAction">
					{{ getMessage_('QWCC001005') }}
				</sf-button>
			</div>
		</div>

		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<mk-obj-popup-table-info1
							ref="tableInfo1"
							:scrId="scrId"
							:sendParam1="sendParam1"
							@OpenDelPopup="OpenDelPopup"
							:sendParam2="sendParam2"
							@OpenConfirmDelPopup="OpenConfirmDelPopup"
						/>
						<mk-obj-popup-table-info2 ref="tableInfo2" :scrId="scrId" />
						<mk-obj-popup-table-info3 ref="tableInfo3" :scrId="scrId" />
						<mk-obj-popup-table-info4 ref="tableInfo4" :scrId="scrId" />
						<mk-obj-popup-table-info5 ref="tableInfo5" :scrId="scrId" />
						<mk-obj-popup-table-info6 ref="tableInfo6" :scrId="scrId" />

						<com-appr-rson-popup ref="apprRsonPop" :scrId="scrId" />
						<!--딜러팝업-->
						<comp-popup ref="compPopup" @SendCpnyData="sendData1" @Refresh="Refresh" :scrId="scrId" />
						<comp-popup-cp ref="compPopup2" @SendCpnyData="sendData2" @Refresh="Refresh" :scrId="scrId" />
						<!--기각-->
						<com-appr-rson-popup ref="pmcApprRsonPopup" @apprRsonfresh="apprRsonfresh" :scrId="scrId" />
					</sf-card>
				</template>
			</div>
		</div>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as Yup from 'yup';

import MkObjPopupTableInfo1 from './Table/MkObjPopupTableInfo1.vue';
import MkObjPopupTableInfo2 from './Table/MkObjPopupTableInfo2.vue';
import MkObjPopupTableInfo3 from './Table/MkObjPopupTableInfo3.vue';
import MkObjPopupTableInfo4 from './Table/MkObjPopupTableInfo4.vue';
import MkObjPopupTableInfo5 from './Table/MkObjPopupTableInfo5.vue';
import MkObjPopupTableInfo6 from './Table/MkObjPopupTableInfo6.vue';

import ComApprRsonPopup from '@qms/comm/commpopup/ComApprRsonPopup/ComApprRsonPopup.vue';
import CompPopup from '@qms/comm/commpopup/CpnyPopup/CpnyPopup.vue'; //협력사 납품업체팝업
import CompPopupCp from '@qms/comm/commpopup/CpnyPopup/CpnyPopup.vue'; //확정협력사 납품업체팝업

import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			mkObjPopUpInfo: {
				title: '', //타이틀명
				clmNo: '', //클레임번호번호
				roNo: '', //RO번호
				fileList: []
			},
			sendParam1: {}, //협력사 납품업체팝업 파리머터 전달
			sendParam2: {} //확정 협력사 납품업체팝업 파리머터 전달
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema1() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크

				bflRpymAmt2: Yup.string() //적용변제금액
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001306')])), ////{0}은(는) 팔수 입력 값 입니다. , 적용변제금액

				bflDvswRt2: Yup.string() //적용분담율
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001305')])), ////{0}은(는) 팔수 입력 값 입니다. , 적용분담율

				bflCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001341')])), //{0}은(는) 팔수 입력 값 입니다. , 납품업체
				mkobRson: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001471')])), //{0}은(는) 팔수 입력 값 입니다. , 이의제기 사유
				mkobType: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001412')])) //{0}은(는) 팔수 입력 값 입니다. , 이의제기타입
			});
		},
		schema2() {
			return Yup.object().shape({
				aplRpymAmt2: Yup.string() //적용변제금액
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001306')])), ////{0}은(는) 팔수 입력 값 입니다. , 적용변제금액

				aplDvswRt2: Yup.string() //적용분담율
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001305')])), ////{0}은(는) 팔수 입력 값 입니다. , 적용분담율

				aplCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001341')])), //{0}은(는) 팔수 입력 값 입니다. , 납품업체
				mkobRson: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001471')])), //{0}은(는) 팔수 입력 값 입니다. , 이의제기 사유
				mkobType: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001412')])) //{0}은(는) 팔수 입력 값 입니다. , 이의제기타입
			});
		}
	},
	components: {
		MkObjPopupTableInfo1,
		MkObjPopupTableInfo2,
		MkObjPopupTableInfo3,
		MkObjPopupTableInfo4,
		MkObjPopupTableInfo5,
		MkObjPopupTableInfo6,
		ComApprRsonPopup /*기각사유 */,
		CompPopup /*딜러점팝업*/,
		CompPopupCp /*협력사 팝업*/
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {},
		apprRsonfresh() {
			this.close();
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.mkObjPopUpInfo.title = param.title;
			this.mkObjPopUpInfo.roNo = param.roNo; //'RO202207300031'; //'RO202207300011'; //param.roNo; //; //param.roNo; /*ro현황에서 디테일 조회시 RO번호가 넘어옴*/
			this.mkObjPopUpInfo.clmNo = param.clmNo; /*PWA신청 현황에서는 PWANo번호만 넘어옴*/
			//let paramClamNo = 'CLM202208100001'; //this.mkObjPopUpInfo.clmNo; //
			let paramClamNo = this.mkObjPopUpInfo.clmNo; //; //

			//초기화
			this.setStateApcnInit_();

			try {
				if (paramClamNo) {
					//console.log('클레임번호 문서번호>>>', paramClamNo);

					this.setStateMkObjPopUp_({ key: 'mkobType', value: '20' });

					const searchClamNo = {
						clmNo: paramClamNo,
						paramState: ''
					};

					await this.getClamNoPopList_(searchClamNo);

					await this.setBtnAuth();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}

			//조회
		},
		setBtnAuth() {
			//console.log('야호>>>>', this.isButton_(this.scrId, 'TS'));

			//초기화
			//this.setBtnTsAuth_(this.isButton_(this.scrId, 'IN'));

			//신청권한
			this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));

			//승인권한
			this.setBtnApprAuth_();
		},
		close() {
			this.isLoading = true;
			this.display = false;
		},
		OpenDelPopup(param) {
			//console.log('딜러점 에서의 cmpnCd 값 ::::: ', param.cmpnCd);

			this.$refs.compPopup.open(param); //.open(param);
		},
		OpenConfirmDelPopup(param) {
			//console.log('딜러점 에서의 cmpnCd 값 ::::: ', param.cmpnCd);

			this.$refs.compPopup2.open(param); //.open(param);
		},
		OpenApprPopup1() {
			/*반려*/
			let paramList = {
				apprState: 'R', //반려
				btnMsg: this.getMessage_('QWCC001003'), //반려
				labelMsg: this.getMessage_('QWCC001146'), //반려
				title: this.getMessage_('QWCC001146'), //반려사유
				cfMsg: this.getMessage_('QWCC001150'), //반려하시겠습니까>?
				apiType: 'MkObj',
				masterKey1: this.mkObjPopUp.clmNo,
				masterKey2: this.mkObjPopUp.nos
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		sendData1(param) {
			//협력사 팝업
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			//console.log('협력사 팝업 result1', param);

			this.sendParam1 = param; //watch감시용
		},
		sendData2(param) {
			//협력사 납품업체팝업
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			//console.log('협력사 납품업체팝업 result2', param);

			this.sendParam2 = param; //watch감시용
		},
		async afterSaveClose() {
			//팝업창 닫고 재조회
			this.$sf_toggleLoading(true);
			this.close();
			this.$emit('Refresh');
		},
		async appSaveAction() {
			//신청
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 유효성 검사

				const selmkobType = convertNvl(this.saveMkObjMst.mkobType, '');

				if (selmkobType != '' && selmkobType != '10') {
					await this.schema1.validateSync(this.saveMkObjMst);
				} else {
					//타사품일경우 확정협력사 를 validation 체크를 한다.
					await this.schema2.validateSync(this.saveMkObjMst);
				}

				//교환부품정보 등록이 되어있나
				if (this.mkObjSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		tmpClearAction() {
			if (this.mkObjPopUp.mkobType == 10) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001982') }); //이의제기 타입이 타사품인 경우는 초기화 할 수가 없습니다.'
				return false;
			}

			this.setStateMkObjPopUp_({ key: 'readOnlyAuth', value: false });
			this.setStateMkObjPopUp_({ key: 'readOnlyAuth1', value: false });
			this.setStateMkObjPopUp_({ key: 'btnApAuth', value: true });

			this.$refs.tableInfo1.setClearInfo();
		},
		async apprSaveAction() {
			//승인처리
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSave() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async save(paramState) {
			//저장
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.saveMkObjMst).forEach(key => formData.append(key, convertNvl(this.saveMkObjMst[key], '')));

			//paramState값은 10은 임시저장, 20번 신청
			formData.append('state', paramState);

			await this.saveMkObjPopup_({ formData })
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//모달창 닫고 재조회
					this.afterSaveClose();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async apprSave() {
			//승인처리
			await this.saveStateAppr_()
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
					//모달창 닫고 재조회
					this.afterSaveClose();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
		/*
		sendData(param) {
			//alert('여기가맛나');
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: url 는 ' + param.url + ', title은 ' + param.title);
		}
		*/
	},
	created() {
		console.clear();
	}
};
</script>

<style></style>
